'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _arrayToDate = require('@marmalade/date/lib/array-to-date');
var _arrayToDate2 = _interopRequireDefault(_arrayToDate);
var _dateArrayToAge = require('@marmalade/date/lib/date-array-to-age');
var _dateArrayToAge2 = _interopRequireDefault(_dateArrayToAge);
var _dateToArray = require('@marmalade/date/lib/date-to-array');
var _dateToArray2 = _interopRequireDefault(_dateToArray);
var _fieldInfo = require('@marmalade/form/lib/selectors/field-info');
var _reselect = require('reselect');
var _constants = require('../constants');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var stage2formId = _constants.stages[1].formId;
var stage4formId = _constants.stages[3].formId;
exports.default = (0, _reselect.createSelector)(function (state) {
  return (0, _fieldInfo.getValue)(state, stage2formId, 'dateOfBirth');
}, function (state) {
  return (0, _fieldInfo.getValue)(state, stage2formId, 'licenceStartDate');
}, function (state) {
  return (0, _fieldInfo.getValue)(state, stage4formId, 'coverStartDate');
}, function (state) {
  return (0, _fieldInfo.getValue)(state, stage2formId, 'addressPostcode');
}, function (dob, licenceStartDate, coverStartDate, postcode) {
  // default to today
  var initCoverStartDate = (0, _dateToArray2.default)();

  // if date in state, check it's not in past, if not, use it
  var today = new Date();
  today.setHours(0, 0, 0, 0);
  if (coverStartDate && (0, _arrayToDate2.default)(coverStartDate) >= today) {
    initCoverStartDate = coverStartDate;
  }

  // if licence start date is in future, bump start date to match
  if ((0, _arrayToDate2.default)(licenceStartDate) > (0, _arrayToDate2.default)(initCoverStartDate)) {
    initCoverStartDate = licenceStartDate;
  }

  // if customer is 16, bump start date to 17th birthday
  var seventeenthBday = [dob[0], dob[1], (~~dob[2] + 17).toString()];
  if ((0, _arrayToDate2.default)(seventeenthBday) > (0, _arrayToDate2.default)(initCoverStartDate)) {
    initCoverStartDate = seventeenthBday;
  }
  return {
    age: (0, _dateArrayToAge2.default)(dob).toString(),
    postcode: postcode,
    initCoverStartDate: initCoverStartDate
  };
});